import { defineMessages } from 'react-intl'

export default defineMessages({
    firstName: {
        defaultMessage: 'Nombre',
    },
    firstNamePlaceholder: {
        defaultMessage: 'Ejemplo: Juan',
    },
    lastNamePlaceholder: {
        defaultMessage: 'Ejemplo: Rodríguez López',
    },
    lastName: {
        defaultMessage: 'Apellido',
    },
    address: {
        defaultMessage: 'Dirección',
    },
    reasonPlaceholder: {
        defaultMessage: 'Concepto de la apelación',
    },
    emailPlaceholder: {
        defaultMessage: 'Ej.: email@email.com',
    },
    addressPlaceholder: {
        defaultMessage: 'Ejemplo: C/ Sesamo, nº32',
    },
    postalCodePlaceholder: {
        defaultMessage: 'Ejemplo: 54321',
    },
    province: {
        defaultMessage: 'Provincia',
    },
    town: {
        defaultMessage: 'Ciudad',
    },
    townPlaceholder: {
        defaultMessage: 'Ejemplo: Monterrey',
    },
    postalCode: {
        defaultMessage: 'Código postal',
    },
    email: {
        defaultMessage: 'Email',
    },
    phone: {
        defaultMessage: 'Teléfono',
    },
    reason: {
        defaultMessage: 'Motivo de apelación',
    },
    description: {
        defaultMessage: 'Descripción de la apelación',
    },
    files: {
        defaultMessage: 'Evidencias',
    },
    selectPhotos: {
        defaultMessage: 'Seleccione los archivos',
    },
    requiredError: {
        defaultMessage: 'Obligatorio',
    },
})
